import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    submitmanuscript: {},
    notification: {},
    articledropdown:{},
    classificationdropdown:{},
    manuscriptlist:{},
    JournalDropdown: {},
};

const submitManuscriptSlice = createSlice({
    name: 'submitmanuscript',
    initialState,
    reducers: {
        setSubmitManuscript(state, action) {
            state.submitmanuscript = action.payload;
        },
        setToast(state, action) {
            state.notification = action.payload;
        },
        setArticleDropdown(state,action)
        {
          state.articledropdown=action.payload;
        },
        setClassificationDropdown(state,action)
        {
          state.classificationdropdown=action.payload
        },
        setManuscriptList(state,action)
        {
          state.manuscriptlist=action.payload
        },
        setJournaldropDown(state, action) {
          state.JournalDropdown = action.payload;
        }

    },
});



export const SubmitManuscriptAddAPi = (values, tokendata) => async (dispatch) => {
    console.log(values, "kjshw2fj");
    const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/author/submitArticleManuScript`, values,
      {
        headers: {
          "authorization": ` Bearer ${tokendata}`
        }
      }
    )
      .then((res) => {
        console.log(res, "fsda3fff")
        // dispatch(setSubmitManuscript(res?.data))
        dispatch(setToast({
          status: true, message: res?.data?.message
        }))
  
      })
      .catch((err) => {
        console.log(err?.response, "wdd98jss");
        dispatch(setToast({
          status: false, message: err?.response?.data?.message
        }))
      })
  
  }

  export const ArticleTypeDropdown=(uuid)=>async(dispatch)=>{
    const response=await axios.get(`${process.env.REACT_APP_BASE_URL}/articleType?journal_uuid=${uuid}`)
    .then((res)=>{
      console.log(res,"jodvfj")
      dispatch(setArticleDropdown(res?.data))
    })
    .catch((err)=>{
      console.log(err?.response,"errorr");
      
    })
  }

  export const ClassificationDropdown = () => async (dispatch) => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/classficationList?page=&limit=`)
      .then((res) => {
        console.log(res, 'rfeferf');
        dispatch(setClassificationDropdown(res?.data?.data));
      })
      .catch((err) => {
        console.log(err?.response, "errrror");
  
      })
  }
 
  export const ManuscriptListAPi=(tokendata,page,limit,search,journal_id)=>async(dispatch)=>{
    const response=await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/author/articleManuscrptList?page=${page}&limit=${limit}&search=${search}&type=submited&journal_uuid=${journal_id}`,
      {
        headers: {
          "authorization": ` Bearer ${tokendata}`
        }
      }
    )
    .then((res)=>{
      console.log(res,"jfdd")
      dispatch(setManuscriptList(res?.data))
    })
    .catch((err)=>{
      console.log(err?.response,"errerrr");
      
    })
  }
  export const JournalDropdownApi = (tokendata) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/journal/dropdownList`, {
      headers: {
        "authorization": ` Bearer ${tokendata}`
      }
    })
      .then((res) => {
        console.log(res, "ssddss");
        dispatch(setJournaldropDown(res?.data));
  
      })
      .catch((err) => {
        console.log(err?.response, "errror");
  
      })
  }
  

  


  



export const { setSubmitManuscript, setToast ,setJournaldropDown,setArticleDropdown,setClassificationDropdown,setManuscriptList} = submitManuscriptSlice.actions;
const SubmitManuscriptReducer = submitManuscriptSlice.reducer;

export default SubmitManuscriptReducer;
